export default __webpack_public_path__ + "static/media/misc-drawerB-1024w.fb03714e.png";